"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAssignProductToOrganizationsMutation = exports.useDisableProductMutation = exports.useEnableProductMutation = exports.useDeleteProductMutation = exports.useUpdateProductMutation = exports.useCreateProductMutation = exports.useGetProductQuery = exports.useLazyGetProductsQuery = exports.useGetProductsQuery = exports.productsApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.productsApi = (0, react_1.createApi)({
    reducerPath: "productsApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Products"],
    endpoints: function (builder) { return ({
        getProducts: builder.query({
            query: function (params) { return ({
                url: "/v1/products",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                return ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.products)
                    ? __spreadArray(__spreadArray([], result.content.products.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Products",
                            id: _id,
                        });
                    }), true), [
                        { type: "Products", id: "LIST" },
                    ], false) : [{ type: "Products", id: "LIST" }];
            },
        }),
        getProduct: builder.query({
            query: function (id) { return "/v1/products/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Products", id: id }]; },
        }),
        createProduct: builder.mutation({
            query: function (data) { return ({
                url: "/v1/products",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: [{ type: "Products", id: "LIST" }],
        }),
        updateProduct: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/products/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Products", id: id },
                    { type: "Products", id: "LIST" },
                ];
            },
        }),
        deleteProduct: builder.mutation({
            query: function (id) { return ({
                url: "/v1/products/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "Products", id: "LIST" }],
        }),
        enableProduct: builder.mutation({
            query: function (id) { return ({
                url: "/v1/products/".concat(id, "/enable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Products", id: id },
                { type: "Products", id: "LIST" },
            ]; },
        }),
        disableProduct: builder.mutation({
            query: function (id) { return ({
                url: "/v1/products/".concat(id, "/disable"),
                method: "POST",
            }); },
            invalidatesTags: function (result, error, id) { return [
                { type: "Products", id: id },
                { type: "Products", id: "LIST" },
            ]; },
        }),
        assignProductToOrganizations: builder.mutation({
            query: function (_a) {
                var id = _a.id, organization_ids = _a.organization_ids;
                return ({
                    url: "/v1/products/".concat(id, "/assign"),
                    method: "POST",
                    body: { organization_ids: organization_ids },
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Products", id: id },
                    { type: "Products", id: "LIST" },
                ];
            },
        }),
    }); },
});
exports.useGetProductsQuery = exports.productsApi.useGetProductsQuery, exports.useLazyGetProductsQuery = exports.productsApi.useLazyGetProductsQuery, exports.useGetProductQuery = exports.productsApi.useGetProductQuery, exports.useCreateProductMutation = exports.productsApi.useCreateProductMutation, exports.useUpdateProductMutation = exports.productsApi.useUpdateProductMutation, exports.useDeleteProductMutation = exports.productsApi.useDeleteProductMutation, exports.useEnableProductMutation = exports.productsApi.useEnableProductMutation, exports.useDisableProductMutation = exports.productsApi.useDisableProductMutation, exports.useAssignProductToOrganizationsMutation = exports.productsApi.useAssignProductToOrganizationsMutation;
